import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import LanguageSwitcher from '../components/LanguageSwitcher';
import AdminAgenciesPage from './AdminAgenciesPage';
import AdminToursPage from './AdminToursPage';

export default function AdminDashboard() {
    const { logout } = useAuth();
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('agencies');

    const tabs = [
        {
            id: 'agencies',
            label: t('agencies'),
            icon: (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
            )
        },
        {
            id: 'tours',
            label: t('tours'),
            icon: (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
            )
        },
    ];

    return (
        <div className="min-h-screen bg-page-gradient">
            {/* Modern Navbar with Gradient */}
            <nav className="bg-hero-luxury border-b border-gold/10 shadow-lg">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between h-16">
                        <div className="flex items-center">
                            <div className="flex items-center gap-3">
                                <div className="p-2 bg-bg-soft border border-gold/30 rounded-lg">
                                    <svg className="w-6 h-6 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                    </svg>
                                </div>
                                <h1 className="text-xl font-bold text-text-invert">{t('adminDashboard')}</h1>
                            </div>
                        </div>
                        <div className="flex items-center gap-2 sm:gap-3">
                            <LanguageSwitcher />
                            <button
                                onClick={logout}
                                className="px-3 py-2 sm:px-4 sm:py-2 text-xs sm:text-sm font-medium text-text-invert bg-bg-card/20 hover:bg-danger-900/30 hover:text-danger-400 border border-gold/20 rounded-lg transition-all duration-300 flex items-center gap-2 min-h-[44px]"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                </svg>
                                <span className="hidden sm:inline">{t('logout')}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </nav>

            <div className="max-w-7xl mx-auto py-6 sm:py-8 px-4 sm:px-6 lg:px-8">
                {/* Tabs */}
                <div className="flex flex-wrap gap-2 sm:gap-3 mb-6 sm:mb-8">
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`px-4 sm:px-6 py-3 rounded-xl font-semibold transition-all duration-300 shadow-md min-h-[44px] ${
                                activeTab === tab.id
                                    ? 'bg-gold-gradient text-white border-none shadow-gold/20 scale-105'
                                    : 'bg-neutralDark text-textMuted border border-gold/10 hover:border-gold/30 hover:text-gold'
                            }`}
                        >
                            <div className="flex items-center gap-2 justify-center">
                                {tab.icon}
                                <span className="text-sm sm:text-base">{tab.label}</span>
                            </div>
                        </button>
                    ))}
                </div>

                {/* Content */}
                {activeTab === 'agencies'    && <AdminAgenciesPage />}
                {activeTab === 'tours'       && <AdminToursPage />}
            </div>
        </div>
    );
}